import SupMangComp from "../../components/SupplierManagement/SupMangComp";

const SupplierManagement = () => {
  return (
    <>
      <SupMangComp />
    </>
  );
};

export default SupplierManagement;
